import { render, staticRenderFns } from "./Readonly.vue?vue&type=template&id=4e237c4a&scoped=true"
import script from "./Readonly.vue?vue&type=script&lang=js"
export * from "./Readonly.vue?vue&type=script&lang=js"
import style0 from "./Readonly.vue?vue&type=style&index=0&id=4e237c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e237c4a",
  null
  
)

export default component.exports